import { render, staticRenderFns } from "./TagsByTypeSelect.vue?vue&type=template&id=35bd8fa0"
import script from "./TagsByTypeSelect.vue?vue&type=script&lang=js"
export * from "./TagsByTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports